import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import { getPatentProofsOptions, useDeletePatentProof, useUploadOrUpdatePatentProof } from './model/PatentProofModel';

interface PatentProofActionProps {
  patentId: number;
  authors: Author[];
  variant?: 'compact';
}

export function PatentProofAction({ patentId, authors }: PatentProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getPatentProofsOptions(patentId));
  const uploadOrUpdateMutation = useUploadOrUpdatePatentProof(patentId);
  const deleteMutation = useDeletePatentProof(patentId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="patent"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
